shadow$provide[252] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Vector:{enumerable:true, get:function() {
  return Vector;
}}});
var UJS = require("../../../util/js.js");
var require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js = require("../../primitive.js");
class Vector extends require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive {
  static initClass() {
    this.traits = ["node", "object", "visible", "style", "line", "arrow", "geometry", "position", "bind", "shade",];
  }
  constructor(node, context, helpers) {
    super(node, context, helpers);
    this.line = this.arrows = null;
  }
  resize() {
    if (this.bind.points == null) {
      return;
    }
    const dims = this.bind.points.getActiveDimensions();
    const samples = dims.items;
    const strips = dims.width;
    const ribbons = dims.height;
    const layers = dims.depth;
    this.line.geometry.clip(samples, strips, ribbons, layers);
    return Array.from(this.arrows).map(arrow => arrow.geometry.clip(samples, strips, ribbons, layers));
  }
  make() {
    let color;
    this._helpers.bind.make([{to:"geometry.points", trait:"source"}, {to:"geometry.colors", trait:"source"},]);
    if (this.bind.points == null) {
      return;
    }
    let position = this._shaders.shader();
    this.bind.points.sourceShader(position);
    this._helpers.position.pipeline(position);
    const styleUniforms = this._helpers.style.uniforms();
    const lineUniforms = this._helpers.line.uniforms();
    const arrowUniforms = this._helpers.arrow.uniforms();
    const unitUniforms = this._inherit("unit").getUnitUniforms();
    const {start, end} = this.props;
    const {stroke, join, proximity, closed} = this.props;
    this.proximity = proximity;
    const dims = this.bind.points.getDimensions();
    const samples = dims.items;
    const strips = dims.width;
    const ribbons = dims.height;
    const layers = dims.depth;
    if (this.bind.colors) {
      color = this._shaders.shader();
      this.bind.colors.sourceShader(color);
    }
    let mask = this._helpers.object.mask();
    let material = this._helpers.shade.pipeline() || false;
    const {swizzle, swizzle2} = this._helpers.position;
    position = swizzle2(position, "yzwx", "yzwx");
    color = swizzle(color, "yzwx");
    mask = swizzle(mask, "yzwx");
    material = swizzle(material, "yzwx");
    const uniforms = UJS.merge(arrowUniforms, lineUniforms, styleUniforms, unitUniforms);
    this.line = this._renderables.make("line", {uniforms, samples, ribbons, strips, layers, position, color, clip:start || end, stroke, join, proximity, closed, mask, material,});
    this.arrows = [];
    if (start) {
      this.arrows.push(this._renderables.make("arrow", {uniforms, flip:true, samples, ribbons, strips, layers, position, color, closed, mask, material,}));
    }
    if (end) {
      this.arrows.push(this._renderables.make("arrow", {uniforms, samples, ribbons, strips, layers, position, color, closed, mask, material,}));
    }
    this._helpers.visible.make();
    return this._helpers.object.make(this.arrows.concat([this.line]));
  }
  made() {
    return this.resize();
  }
  unmake() {
    this._helpers.bind.unmake();
    this._helpers.visible.unmake();
    this._helpers.object.unmake();
    return this.line = this.arrows = null;
  }
  change(changed, _touched, _init) {
    if (changed["geometry.points"] || changed["line.stroke"] || changed["line.join"] || changed["arrow.start"] || changed["arrow.end"]) {
      return this.rebuild();
    }
    if (changed["line.proximity"]) {
      if (this.proximity != null !== (this.props.proximity != null)) {
        return this.rebuild();
      }
    }
  }
}
Vector.initClass();

};